module.exports = {
  address: "0xc132C7B178FBA4861133D552483C7950830Cb134",
  address_test: '',
  abi: require('./PromotionReward.abi.json')
}
